import { forwardRef, useEffect } from 'react';

export const AutoScrollToElement = forwardRef(
  (
    { behavior = 'smooth', block = 'end', inline = 'nearest', timeout = 400 },
    ref
  ) => {
    useEffect(() => {
      if (!ref.current) {
        return;
      }
      setTimeout(() => {
        if (!ref.current) {
          return;
        }
        ref.current.scrollIntoView({
          behavior,
          block,
          inline,
        });
      }, timeout);
    }, []);
  }
);

export const AutoScrollToQuery = forwardRef(
  (
    {
      query,
      behavior = 'smooth',
      block = 'end',
      inline = 'nearest',
      timeout = 400,
    },
    ref
  ) => {
    useEffect(() => {
      if (!ref.current) {
        return;
      }
      setTimeout(() => {
        if (!ref.current) {
          return;
        }
        ref.current.scrollIntoView({
          behavior,
          block,
          inline,
        });
      }, timeout);
    }, [query.isLoading, query.isFetching]);

    useEffect(() => {
      if (!ref.current) {
        return;
      }
      setTimeout(() => {
        if (!ref.current) {
          return;
        }
        ref.current.scrollIntoView({
          behavior,
          block,
          inline,
        });
      }, timeout);
    }, [query.data]);
    return null;
  }
);
